module.exports = __webpack_public_path__ + "static/img/login_background.496df91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_background.png
// module id = eGJy
// module chunks = 1